__webpack_require__.p = "/metallica-blacklist/";